// core components
// admin pages
// // // // // admin dashboards
import Dashboard from "views/admin/Dashboards/Dashboard.js";
import Pos from "views/admin/Pos/Pos.js";
import PosSales from "views/admin/Pos/PosSales.js";
// auth pages
import Login from "views/auth/Login.js";
// @material-ui/icons components
import AddCommentIcon from '@material-ui/icons/AddComment';
import Exit from "@material-ui/icons/ExitToApp";
import House from "@material-ui/icons/House";
import Map from "@material-ui/icons/Map";
import Receipt from "@material-ui/icons/Receipt";
import People from "@material-ui/icons/People";
import LocalLaundryService from "@material-ui/icons/LocalLaundryService";
import Store from "@material-ui/icons/Store";
import MonetizationOn from "@material-ui/icons/MonetizationOn";
import SupervisorAccount from "@material-ui/icons/SupervisorAccount";
import AttachMoney from "@material-ui/icons/AttachMoney";
import Star from "@material-ui/icons/Star";
import DirectionsCar from "@material-ui/icons/DirectionsCar";
import EventAvailable from "@material-ui/icons/EventAvailable";
import ViewCarousel from "@material-ui/icons/ViewCarousel";
import LiveHelp from "@material-ui/icons/LiveHelp";
import NotificationsIcon from "@material-ui/icons/Notifications";
import Settings from "@material-ui/icons/Settings";
import ShoppingCart from "@material-ui/icons/ShoppingCart";
import FaqRoute from "routes/FaqRoute";
import AdminParamsRoute from "routes/AdminParamsRoute";
import ReviewsRoute from "routes/ReviewsRoute";
import CountriesRoute from "routes/CountriesRoute";
import CouponsRoute from "routes/CouponsRoute";
import ConsoleUsersRoute from "routes/ConsoleUsersRoute";
import PushNotificationRoute from "routes/PushNotificationRoute";
import LogoutRoute from "routes/LogoutRoute";
import DriversRoute from "routes/DriversRoute";
import VehiclesRoute from "routes/VehiclesRoute";
import DriverShiftsRoute from "routes/DriverShiftsRoute";
import AvailabilitySlotsRoute from "routes/AvailabilitySlotsRoute";
import TransactionsRoute from "routes/TransactionsRoute";
import ServicesRoute from "routes/ServicesRoute";
import UsersRoute from "routes/UsersRoute";
import BannersRoute from "routes/BannersRoute";
import OrdersRoute from "routes/OrdersRoute";
import LaundriesRoute from "routes/LaundriesRoute";
import LaundryOrdersRoute from "routes/LaundryOrdersRoute";
import LaundryOrdersViewRoute from "routes/LaundryOrdersViewRoute";
import SortedLaundryOrdersRoute from "routes/SortedLaundryOrdersRoute";
import SubscriptionPackagesRoute from "routes/SubscriptionPackagesRoute";
import { AccessTimeTwoTone, AccountBalanceWallet, CardGiftcard, CardMembership, PersonPin, Repeat, TimerRounded, ViewDay } from "@material-ui/icons";
import SubscriptionRoute from "routes/SubscriptionRoute";
import AmenitiesRoute from "routes/AmenitiesRoute";
import WalletRoute from "routes/WalletRoute";
import ProSubscriptionPackagesRoute from "routes/ProSubscriptionPackagesRoute";
import ComplaintsRoute from "routes/ComplaintsRoute";
import ProSubscriptionsRoute from "routes/ProSubscriptionPackagesRoute copy";

var routes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    iconColor: "Info",
    icon: House,
    component: Dashboard,
    layout: "/admin",
    role: 'admin',
    permission: ''
  },
  {
    collapse: true,
    name: "POS Manage",
    icon: ShoppingCart,
    iconColor: "Info",
    state: "posManageCollapse",
    role: "admin",
    permission: "",
    views: [
      {
        path: "/pos",
        name: "POS",
        miniName: "P",
        icon: Store,
        component: Pos,
        layout: "/admin",
        role: "admin",
        permission: ""
      },
      {
        path: "/pos-sales",
        name: "POS Sales",
        miniName: "PS",
        icon: Receipt,
        component: PosSales,
        layout: "/admin",
        role: "admin",
        permission: ""
      }
    ]
  },
  {
    path: "/pro-subscriptions",
    name: "Pro Subscriptions",
    iconColor: "Info",
    icon: Repeat,
    component: ProSubscriptionsRoute,
    layout: "/admin",
    role: 'admin',
    permission: 'SUBSCRIPTIONS'
  },
  {
    path: "/subscriptions",
    name: "Subscriptions",
    iconColor: "Info",
    icon: AccessTimeTwoTone,
    component: SubscriptionRoute,
    layout: "/admin",
    role: 'admin',
    permission: 'SUBSCRIPTIONS'
  },
  {
    path: "/orders",
    name: "Orders",
    iconColor: "Info",
    icon: Receipt,
    component: OrdersRoute,
    layout: "/admin",
    role: 'admin',
    permission: 'ORDERS'
  },
  {
    path: "/laundryOrders",
    name: "Orders",
    iconColor: "Info",
    icon: Receipt,
    component: LaundryOrdersRoute,
    layout: "/admin",
    role: 'laundry',
    permission: 'LAUNDRY'
  },
  {
    path: "/laundryOrdersView",
    name: "LaundryOrders",
    iconColor: "Info",
    icon: Receipt,
    component: LaundryOrdersViewRoute,
    layout: "/admin",
    role: 'admin',
    permission: 'LAUNDRY'
  },
  {
    path: "/sortedLaundryOrders",
    name: "Sorted Orders",
    iconColor: "Info",
    icon: Receipt,
    component: SortedLaundryOrdersRoute,
    layout: "/admin",
    role: 'laundry',
    permission: 'LAUNDRY'
  },
  {
    path: "/users",
    name: "Users",
    iconColor: "Info",
    icon: People,
    component: UsersRoute,
    layout: "/admin",
    role: 'admin',
    permission: 'USERS'
  },
  {
    path: "/complaints",
    name: "Complaints",
    icon: AddCommentIcon,
    iconColor: "Info",
    component: ComplaintsRoute,
    layout: "/admin",
    role: 'admin',
    permission: 'COMPLAINTS'
  },
  {
    path: "/amenities",
    name: "Amenities Log",
    iconColor: "Info",
    icon: CardGiftcard,
    component: AmenitiesRoute,
    layout: "/admin",
    role: 'admin',
    permission: 'AMENITIES'
  },
  {
    path: "/services",
    name: "Services",
    iconColor: "Info",
    icon: LocalLaundryService,
    component: ServicesRoute,
    layout: "/admin",
    role: 'admin',
    permission: 'SERVICES'
  },
  {
    path: "/coupons",
    name: "Coupons",
    iconColor: "Info",
    icon: AttachMoney,
    component: CouponsRoute,
    layout: "/admin",
    role: 'admin',
    permission: 'COUPONS'
  },
  {
    path: "/transactions",
    name: "Transactions",
    iconColor: "Info",
    icon: MonetizationOn,
    component: TransactionsRoute,
    layout: "/admin",
    role: 'admin',
    permission: 'TRANSACTIONS'
  },
  {
    path: "/wallet",
    name: "Wallet",
    iconColor: "Info",
    icon: AccountBalanceWallet,
    component: WalletRoute,
    layout: "/admin",
    role: 'admin',
    permission: 'USER_WALLET'
  },
  {
    path: "/reviews",
    name: "Reviews",
    iconColor: "Info",
    icon: Star,
    component: ReviewsRoute,
    layout: "/admin",
    role: 'admin',
    permission: 'REVIEWS'
  },
  {
    path: "/drivers",
    name: "Drivers",
    iconColor: "Info",
    icon: PersonPin,
    component: DriversRoute,
    layout: "/admin",
    role: 'admin',
    permission: 'DRIVERS'
  },
  {
    path: "/vehicles",
    name: "Vehicles",
    iconColor: "Info",
    icon: DirectionsCar,
    component: VehiclesRoute,
    layout: "/admin",
    role: 'admin',
    permission: 'None'
  },
  {
    path: "/driver-shifts",
    name: "Driver Shifts",
    iconColor: "Info",
    icon: TimerRounded,
    component: DriverShiftsRoute,
    layout: "/admin",
    role: 'admin',
    permission: 'None'
  },
  {
    path: "/availability-slots",
    name: "Slots",
    iconColor: "Info",
    icon: EventAvailable,
    component: AvailabilitySlotsRoute,
    layout: "/admin",
    role: 'admin',
    permission: 'SLOTS'
  },
  {
    path: "/banners",
    name: "Banners",
    iconColor: "Info",
    icon: ViewCarousel,
    component: BannersRoute,
    layout: "/admin",
    role: 'admin',
    permission: 'BANNERS'
  },
  {
    path: "/faq",
    name: "Faq",
    iconColor: "Info",
    icon: LiveHelp,
    component: FaqRoute,
    layout: "/admin",
    role: 'admin',
    permission: 'FAQ'
  },
  {
    path: "/push-notification",
    name: "Push Notification",
    iconColor: "Info",
    icon: NotificationsIcon,
    component: PushNotificationRoute,
    layout: "/admin",
    role: 'admin',
    permission: 'NOTIFICATIONS'
  },
  {
    path: "/laundries",
    name: "Laundries",
    iconColor: "Info",
    icon: Store,
    component: LaundriesRoute,
    layout: "/admin",
    role: 'admin',
    permission: 'LAUNDRIES'
  },
  {
    path: "/country",
    name: "Countries",
    iconColor: "Info",
    icon: Map,
    component: CountriesRoute,
    layout: "/admin",
    role: 'admin',
    permission: 'COUNTRIES',
    invisible: true
  },
  {
    path: "/city",
    name: "Cities",
    iconColor: "Info",
    icon: Map,
    component: CountriesRoute,
    layout: "/admin",
    role: 'admin',
    // permission: 'COUNTRIES'
  },
  {
    path: "/console-user",
    name: "Admins",
    iconColor: "Info",
    icon: SupervisorAccount,
    component: ConsoleUsersRoute,
    layout: "/admin",
    role: 'admin',
    permission: 'ADMIN'
  },
  {
    path: "/subscription-pkgs",
    name: "Subscription Pkgs.",
    iconColor: "Info",
    icon: ViewDay,
    component: SubscriptionPackagesRoute,
    layout: "/admin",
    role: 'admin',
    permission: 'SUBSCRIPTION_PACKAGES'
  },
  {
    path: "/pro-subscription-pkgs",
    name: "Pro Pkgs.",
    iconColor: "Info",
    icon: CardMembership,
    component: ProSubscriptionPackagesRoute,
    layout: "/admin",
    role: 'admin',
    permission: 'SUBSCRIPTION_PACKAGES'
  },
  {
    path: "/config",
    name: "Config",
    iconColor: "Info",
    icon: Settings,
    component: AdminParamsRoute,
    layout: "/admin",
    role: 'admin',
    permission: 'CONFIG'
  },
  {
    path: "/login",
    name: "Login",
    miniName: "L",
    component: Login,
    layout: "/auth",
    role: 'demo',
    permission: ''
  },
  {
    divider: true,
    role: 'admin',
    permission: ''
  },
  {
    title: "Actions",
    role: 'admin',
    permission: ''
  },
  {
    title: "Actions",
    role: 'laundry',
    permission: ''
  },
  {
    path: "/logout",
    name: "Log out",
    icon: Exit,
    iconColor: "Error",
    component: LogoutRoute,
    layout: "/admin",
    role: 'admin',
    permission: ''
  },
  {
    path: "/logout",
    name: "Log out",
    icon: Exit,
    iconColor: "Error",
    component: LogoutRoute,
    layout: "/admin",
    role: 'laundry',
    permission: ''
  }

];
export default routes;
